import { updateTenant, UpdateTenant } from '@infuse/api/iam/tenant';
import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useUpdateTenant = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  const mutation = useMutation<unknown, unknown, { id: string; tenant: UpdateTenant }>({
    mutationFn: async ({ id, tenant }) => {
      try {
        await updateTenant({ id }, tenant);
        notify({
          title: t('iam.tenants.header.update_tenant'),
          message: t('iam.tenants.notify.update_tenant_success')
        });
      } catch (e) {
        notify({
          type: UiNotificationType.ERROR,
          title: t('iam.tenants.header.update_tenant'),
          message: getAxiosErrorMessage(e, t('iam.tenants.notify.update_tenant_failed'))
        });
        throw e;
      }
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['tenants'] });
    }
  });

  return {
    ...mutation
  };
};
